import { Pipe, PipeTransform, Injectable } from '@angular/core';

type StatusBadge = {
  text: string;
  class: string;
  title: string;
};

@Pipe({
  name: 'statusBadge',
  pure: true,
  standalone: true,
})
@Injectable({ providedIn: 'root' })
export class StatusBadgePipe implements PipeTransform {

  private STATUS_MAP: Record<string, StatusBadge> = {
    scheduled: {
      text: 'S',
      class: 'status-scheduled',
      title: 'Scheduled'
    },
    assistant_doctor: {
      text: 'AD',
      class: 'status-assistant-doctor',
      title: 'Assistant Doctor'
    },
    assistant_doctor_done: {
      text: 'AD',
      class: 'status-assistant-doctor',
      title: 'Assistant Doctor'
    },
    doctor: {
      text: 'D',
      class: 'status-doctor',
      title: 'Doctor'
    },
    medicine: {
      text: 'P',
      class: 'status-pharmacy',
      title: 'Pharmacy'
    },
    reception: {
      text: 'R',
      class: 'status-reception',
      title: 'Reception'
    },
    // receptionist: {
    //   text: 'R',
    //   class: 'status-reception',
    //   title: 'Reception'
    // }
  };

  transform(status: string): StatusBadge | null {
    return this.STATUS_MAP[status] ?? null;
  }

}
